import React, { createRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  loadWaitList,
  getSettings,
  deleteWaitListSubscriber,
  deleteWaitListSubscriberReceived,
  loadWaitListDownloadLink,
} from "store/settings";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Joi from "joi-browser";
import _ from "lodash";
import { saveAs } from "file-saver";

//  Images
import plusIcon from "include/images/plus.svg";
import historyIcon from "include/images/history-icon.svg";
import carrentIcon from "include/images/carrent-icon.svg";
import emptyIcon from "include/images/nrf.svg";

//  Components
import Form from "common/form/form";
import Header from "common/header";
import SideBar from "common/sidebar";
import Loader from "common/loader";
import DeleteModal from "common/alert/alertModal";
import AlertSuccess from "common/alert/alertSuccess";
import AlertError from "common/alert/alertError";
import NextButton from "common/form/submitButton";
import HistoryFlyer from "common/historyFlyer";
import { truncateAddress } from "utils/misc";

class Listing extends Form {
  ref = createRef(null);
  state = {
    loading: false,
    errors: {},
    showDeleteModal: false,
    loadingDelete: false,
    deleteId: "",
    id: "",
    loadingDownload: false,
    showHistory: false,
    objectId: "",
    object: null,
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (!this.props.getSettings.loading && this.props.getSettings.loading !== prevProps.getSettings.loading)
      this.ref.current.complete();

    if (this.props.getSettings.loading && this.props.getSettings.loading !== prevProps.getSettings.loading)
      this.ref.current.continuousStart();
  };

  componentDidMount = () => {
    this.setState({ loading: true });
    this.props.loadWaitList(() => {
      this.setState({ loading: false });
    });
  };
  alertModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };
  toggleHistoryFlyer = (e) => {
    if (e) e.preventDefault();
    this.setState({ showHistory: !this.state.showHistory });
  };
  handleDelete = (e) => {
    if (e) e.preventDefault();
    this.setState({ loadingDelete: true });
    this.props.deleteWaitListSubscriberReceived({ id: this.state.id });
    this.props.deleteWaitListSubscriber(this.state.deleteId, (subscriberRes) => {
      if (subscriberRes.status == 200) {
        toast(<AlertSuccess message="Deleted!" />, {
          containerId: 1,
        });

        this.alertModalToggle();
        this.setState({ loadingDelete: false });
      } else {
        toast(<AlertError message={subscriberRes.data && subscriberRes.data.message} />, {
          containerId: 1,
        });
        this.alertModalToggle();
        this.setState({ loadingDelete: false });
      }
    });
  };

  render() {
    const { waitList, totalCount } = this.props.getSettings;
    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="website-settings" />
          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>Waiting List {totalCount > 0 && `(${totalCount})`}</h1>{" "}
              <div className="filter-menu-box d-flex align-items-center ms-auto">
                {" "}
                <div className="fmb-box">
                  <a
                    href="#!"
                    className="filter-link-box"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState(
                        {
                          objectId: "",
                          object: null,
                        },
                        () => {
                          this.toggleHistoryFlyer();
                        },
                      );
                    }}
                  >
                    <img src={historyIcon} /> <span>History</span>
                  </a>
                </div>
                <div className="fmb-box">
                  <NextButton
                    handleSubmit={(e) => {
                      e.preventDefault();
                      this.setState({ loadingDownload: true });
                      this.props.loadWaitListDownloadLink((res) => {
                        if (res.status === 200) {
                          saveAs(res.data.data, "bg-waiting-list");
                        }
                        setTimeout(() => {
                          this.setState({ loadingDownload: false });
                        }, 500);
                      });
                    }}
                    label="Export Waiting List"
                    loading={this.state.loadingDownload}
                    classData={"btn btn-default btn-sm"}
                  />
                </div>
              </div>
            </div>
            <div className="fwc-wrapper">
              <div className="fwc-body">
                {!this.state.loading && (
                  <div className="table-responsive">
                    {waitList.length === 0 ? (
                      <div className="fwc-body">
                        <div className="no-record-found-container">
                          <div className="nfr-box">
                            <img src={emptyIcon} alt="No Record Found" />
                            <div className="nrf-text">
                              <h5>No Records Found!</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <table className="table large-table">
                        <thead>
                          <tr>
                            <th style={{ width: 75, textAlign: "center" }}>Actions</th>
                            <th>Email</th>
                            <th>Wallet Address</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {waitList.map((subscriber, i) => (
                            <tr>
                              <td>
                                <Dropdown className=" custom-dropdown">
                                  <Dropdown.Toggle
                                    id="tdDropdownOne"
                                    className="custom-dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <img src={carrentIcon} alt="" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className={`dropdown-menu-start `} aria-labelledby="tdDropdownOne">
                                    <Dropdown.Item
                                      className="dropdown-item delete"
                                      onClick={(e) => {
                                        this.setState({ deleteId: subscriber.walletAddress, id: subscriber.id }, () =>
                                          this.alertModalToggle(e),
                                        );
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                              <td>{subscriber.email}</td>
                              <td>
                                <a
                                  href="#"
                                  className="orange-text"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigator.clipboard.writeText(subscriber.walletAddress);
                                    toast(<AlertSuccess message="Copied to clipboard" />, { containerId: 1 });
                                  }}
                                >
                                  {truncateAddress(subscriber.walletAddress)}
                                </a>
                              </td>{" "}
                              <td>{moment(subscriber.updatedAt).format("MM/DD/YYYY hh:mm A")}</td>{" "}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>{" "}
        <DeleteModal
          alertModalToggle={this.alertModalToggle}
          alertModalShow={this.state.showDeleteModal}
          title="Alert"
          description="Are you sure you want to delete this item?"
          onPress={this.handleDelete}
          loading={this.state.loadingDelete}
        />
        <HistoryFlyer
          showModal={this.state.showHistory}
          toggleModal={this.toggleHistoryFlyer}
          moduleName={"waitList"}
          objectId={this.state.objectId}
          title={this.state.object && this.state.object.email}
        />
        {this.state.showHistory && <div className="modal-backdrop show fade" onClick={this.toggleHistoryFlyer}></div>}
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  loadWaitList: (callback) => dispatch(loadWaitList(callback)),
  loadWaitListDownloadLink: (callback) => dispatch(loadWaitListDownloadLink(callback)),
  deleteWaitListSubscriber: (email, callback) => dispatch(deleteWaitListSubscriber(email, callback)),
  deleteWaitListSubscriberReceived: (payLoad) => dispatch(deleteWaitListSubscriberReceived(payLoad)),
});
const mapStateToProps = (state) => ({
  getSettings: getSettings(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Listing));
